<div align="right;"><button mat-stroked-button color="" [mat-dialog-close]="true" class="button-close">X</button></div>
<br/><br/>
<div fxLayout="row" fxLayoutAlign="center center" align="center">
    <mat-card>
        <h2>Verifica que esta cuenta te pertenece.
		<br/>
			<div *ngIf="formaEnvio == '3'">Elige cómo recibir el código de verificación:</div>
		</h2>
        <h2></h2>
        <br />
        <div class="choice" (click)="sendCode('validatecode',2)" [mat-dialog-close]="true" *ngIf="phone != undefined && formaEnvio == '3' && formaEnvioDigitoVerificador != '3'">
            <div align="left"  class="choice-item">SMS<br />
                Al celular terminado en {{phone}} 
            </div>
            <div> </div>
        </div>
        <br />
        <div class="choice" (click)="sendCode('validatecode',1)" [mat-dialog-close]="true" *ngIf="email != undefined && formaEnvio == '3' && formaEnvioDigitoVerificador != '2'">
            <div align="left" class="choice-item">EMAIL<br />
                A la casilla {{email}}
            </div>
            <div> </div>
        </div>
		<div class="choice" (click)="sendEmail('recovery',1)" [mat-dialog-close]="true" *ngIf="email != undefined && formaEnvio == '1'">
            <div align="left" class="choice-item">EMAIL<br />
                A la casilla {{email}}
            </div>
            <div> </div>
        </div>
		<div class="choice" (click)="sendEmail('recovery',2)" [mat-dialog-close]="true" *ngIf="email != undefined && formaEnvio == '2'">
            <div align="left" class="choice-item">EMAIL<br />
                A la casilla {{email}}
            </div>
            <div> </div>
        </div>
        <br /><br />
		<div *ngIf="formaEnvio == '3' && ((email != undefined && phone != undefined) || email == undefined)">
        <h4 class="text-italic"> ¿No reconoces ese celular o casilla de mail? <br />
            Comunícate con el CAN para actualizarlos. </h4>
		</div>
		<div *ngIf="(formaEnvio == '3' && email != undefined && phone == undefined) || (formaEnvio != '3')">
        <h4 class="text-italic"> ¿No reconoces este mail? <br />
            Comunícate con el CAN o CEN para actualizarlos. </h4>
		</div>
        <br />
        <button mat-stroked-button color="" class="button-cancel" [mat-dialog-close]="true" cdkFocusInitial>ANULAR</button>
    </mat-card>
</div>